import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import { Layout } from "./components/Layout";
import GameDetails from "./pages/GameDetails";
import VersionDetails from "./pages/VersionDetails";
import Statistics from "./pages/Statistics";
import NewGame from "./pages/NewGame";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Export from "./pages/Export";
import { SettingsPage } from "./pages/SettingsPage"; // Import SettingsPage
import AdminPanel from "./pages/AdminPanel"; // Import AdminPanel
import GeminiApiKeyManagement from "./pages/GeminiApiKeyManagement"; // Import GeminiApiKeyManagement
import AdminUser from "./pages/AdminUser"; // Import AdminUser
import Translate from "./pages/Translate"; // Import Gomb1Page
import Gomb2Page from "./pages/Gomb2Page"; // Import Gomb2Page
import Gomb3Page from "./pages/Gomb3Page"; // Import Gomb4Page
import Gomb4Page from "./pages/Gomb4Page"; // Import Gomb4Page
import Gomb5Page from "./pages/Gomb5Page"; // Import Gomb5Page
import Gomb6Page from "./pages/Gomb6Page"; // Import Gomb6Page
import Gomb7Page from "./pages/Gomb7Page"; // Import Gomb7Page
import Gomb8Page from "./pages/Gomb8Page"; // Import Gomb8Page
import Gomb9Page from "./pages/Gomb9Page"; // Import Gomb9Page
import Gomb10Page from "./pages/Gomb10Page"; // Import Gomb10Page
import Gomb11Page from "./pages/Gomb11Page"; // Import Gomb11Page
import Gomb12Page from "./pages/Gomb12Page"; // Import Gomb12Page

import { UserProvider } from "../context/UserContext"; // Import UserProvider
import { ThemeProvider } from "../context/ThemeContext";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <ThemeProvider defaultTheme="weblate">
        <UserProvider> {/* UserProvider should wrap BrowserRouter */}
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/games" element={<Index />} />
                <Route path="/games/new" element={<NewGame />} />
                <Route path="/games/:gameId" element={<GameDetails />} />
                <Route path="/games/:gameId/versions/:versionId" element={<VersionDetails />} />
                <Route path="/games/:gameId/versions/:versionId/translate" element={<Translate />} />
                <Route path="/games/:gameId/versions/:versionId/translate/:fileId" element={<Translate />} />
                <Route path="/games/:gameId/versions/:versionId/statistics" element={<Statistics />} />
                <Route path="/games/:gameId/versions/:versionId/statistics/:fileId" element={<Statistics />} />
                <Route path="/games/:gameId/versions/:versionId/files/:fileId/statistics" element={<Statistics />} />
                <Route path="/games/:gameId/versions/:versionId/gomb2" element={<Gomb2Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb3" element={<Gomb3Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb4" element={<Gomb4Page />} />
                <Route path="/games/:gameId/versions/:versionId/file_management" element={<Gomb4Page />} />
                <Route path="/games/:gameId/versions/:versionId/translation_files/:fileId/file_management" element={<Gomb4Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb5" element={<Gomb5Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb6" element={<Gomb6Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb7" element={<Gomb7Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb8" element={<Gomb8Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb9" element={<Gomb9Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb10" element={<Gomb10Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb11" element={<Gomb11Page />} />
                <Route path="/games/:gameId/versions/:versionId/gomb12" element={<Gomb12Page />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/export" element={<Export />} />
                <Route path="/settings" element={<SettingsPage />} /> {/* New route for SettingsPage */}
                <Route path="/adminPanel" element={<AdminPanel />} /> {/* Admin Panel route */}
                <Route path="/adminPanel/gemini-apikey" element={<GeminiApiKeyManagement />} /> {/* Gemini API Key Management route */}
                <Route path="/admin/users" element={<AdminUser />} /> {/* Admin User Management route */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </UserProvider> {/* Correctly close UserProvider here */}
      </ThemeProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;